import { useMemo } from 'react';
import { useHistory } from 'react-router';

import { fromPathnameToIsWeek } from 'bl/pathname.bl';
import navFor from 'utils/links/navFor.util';

import { usePathname } from './usePathname.hook';

export const useNavFor = (...tags) => {
  const history = useHistory();

  tags.unshift('useNavFor()');

  return useMemo(() => navFor(tags, { history }), [history, tags]);
};

export const useNavIsWeek = () => {
  const pathname = usePathname();
  return fromPathnameToIsWeek(pathname);
};
